import React from 'react';
import { Create, useForm } from '@refinedev/antd';
import { Form } from 'antd';
import { normalizeTranslations } from '../../components/LocalizedContentTabs';
import { PetSkinCategoryFormFields, PET_SKIN_CATEGORY_LANG_FIELDS } from './fields';

export const PetSkinCategoryCreate: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'pet-skin-categories' });

  return (
    <Create resource="pet-skin-categories" saveButtonProps={saveButtonProps}>
      <Form
        {...formProps}
        layout="vertical"
        initialValues={{ sortOrder: 0, isActive: true }}
        onFinish={(values: any) =>
          formProps.onFinish?.({
            ...values,
            slug: values.slug || undefined,
            translations: normalizeTranslations(
              values.translations,
              PET_SKIN_CATEGORY_LANG_FIELDS,
            ),
          })
        }
      >
        <PetSkinCategoryFormFields slugEditable />
      </Form>
    </Create>
  );
};
